export let  excludeRoutesArray:string[]=[]
excludeRoutesArray=['/auth/login']
